var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        _vm.$style["dot-load"],
        _vm.theme && _vm.$style[`dot-load--${_vm.theme}`],
      ],
    },
    [
      _c("span", { class: [_vm.$style.dot, _vm.$style["dot-1"]] }),
      _c("span", { class: [_vm.$style.dot, _vm.$style["dot-2"]] }),
      _c("span", { class: [_vm.$style.dot, _vm.$style["dot-3"]] }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }